/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of the Spark engine
*/
export enum SparkEngineStatus {
  SPARK_ENGINE_STATUS_CREATING = 'CREATING',
  SPARK_ENGINE_STATUS_CREATE_FAILED = 'CREATE_FAILED',
  SPARK_ENGINE_STATUS_STOPPED = 'STOPPED',
  SPARK_ENGINE_STATUS_STARTING = 'STARTING',
  SPARK_ENGINE_STATUS_STARTED = 'STARTED',
  SPARK_ENGINE_STATUS_STOPPING = 'STOPPING',
  SPARK_ENGINE_STATUS_DELETING = 'DELETING'
}
